// extracted by mini-css-extract-plugin
export default {"TimeTable":"TimeTable_TimeTable__Ut4fo","TimeTableFrame":"TimeTable_TimeTableFrame__2obFA","TimeTableMobile":"TimeTable_TimeTableMobile__cdwez"};